import { BankAccount } from './bank-account.model';
import { Address } from './address.model';

export enum Genders {
    Male = 'male',
    Female = 'female',
}



export class Person {
    constructor(
        public firstName?: string,
        public lastName?: string,
        public phoneNumber?: string,
        public gender?: Genders,
        public bankAccounts?: BankAccount[],
        public addresses?: Address[],
        public fullName?: string,
    ) { }

    static adapt(item: any): Person {
        return new Person(
            item.firstName,
            item.lastName,
            item.phoneNumber,
            item.gender,
            item.bankAccounts ? item.bankAccounts.map(BankAccount.adapt) : [],
            item.addresses ? item.addresses.map(Address.adapt) : [],
            `${item.firstName || ''} ${item.lastName || ''}`
        );
    }
}